<template>
    <div class="page flex-col">
        <div class="block1 flex-col">
            <span class="txt1">{{ this.userInfo.taskName }}</span>
            <span class="info1">赠送商品</span>
            <div class="outer3 flex-col">
                <div class="main5 flex-row">
                    <img class="pic1" referrerpolicy="no-referrer"
                        :src="`https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/${this.userInfo.imageUrl}`" />
                    <div class="group1 flex-col">
                        <div class="main6 flex-row">
                            <span class="info2">商品名称:{{ this.userInfo.description }}</span>
                            <span class="txt2">商品赠送</span>
                        </div>
                        <span class="word4">{{ userInfo.name }}</span>
                        <span class="info3">商品价格:</span>
                        <span class="word5">{{ this.userInfo.price / 100 }}&nbsp;元</span>
                    </div>
                </div>
            </div>
            <div class="outer4 flex-row">
                <span class="word6">到店用户</span>
                <span class="txt3">{{ this.str }}</span>
            </div>
            <div class="outer5 flex-col">
                <div class="main7 flex-col">
                    <div class="section1 flex-row">
                        <img class="block2 flex-col" referrerpolicy="no-referrer"
                            :src="`https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/${this.userInfo.avatarUrl}`" />
                        <div class="block3 flex-col">
                            <span class="word7">{{
                                this.userInfo.nickName
                                }}</span>
                            <div class="main8 flex-row">
                                <span class="txt4">信誉分：</span>
                                <span class="word8">{{
                                    this.userInfo.credit
                                    }}</span>
                            </div>
                            <div class="main9 flex-row">
                                <span class="word9">粉丝数量：</span>
                                <span class="txt5">{{
                                    this.userInfo.fansAmount
                                    }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="section2 flex-col"></div>
                    <div class="section3 flex-row">
                        <span class="txt6">真实姓名:</span>
                        <span class="info4">{{
                            this.userInfo.identityName
                            }}</span>
                        <span class="word10">身份证后四位：</span>
                        <span class="word11">{{
                            String(this.userInfo.identityNo).slice(14, 18)
                            }}</span>
                    </div>
                    <div class="section4 flex-row">
                        <span class="word12">应到店时间：</span>
                        <div class="outer6">
                            <span class="txt7">
                                {{
                                    String(this.userInfo.applyStartTime).slice(
                                        0,
                                        10
                                    )
                                }}
                            </span>
                            <span class="word13"></span>
                            <span class="word14">—</span>
                            <span class="word15"></span>
                            <span class="info5">
                                {{
                                    String(this.userInfo.applyEndTime).slice(
                                        0,
                                        10
                                    )
                                }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <button class="outer7 flex-col">
                <button class="word16" @click="determine">确认到店</button>
            </button>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import { fetchArrive, fetchUserAndProductDetail } from "@/services/task";
export default {
    name: "Shop",
    data() {
        return {
            userInfo: {},
            str: "",
            avater: "",
            taskApplyId: "",
        };
    },
    created() {
        this.taskApplyId = this.$route.query.taskApplyId;
        this.getInfo();
    },
    methods: {
        getInfo() {
            this.openLoading();
            fetchUserAndProductDetail(this.taskApplyId)
                .then((res) => {
                    if (res.data) {
                        this.userInfo = res.data;
                        this.calculation(
                            res.data.applyStartTime,
                            res.data.applyEndTime
                        );
                    } else {
                        this.$router.push("/fail");
                    }

                })
                .finally(() => {
                    this.closeLoading();
                });
        },
        calculation(start, ent) {
            if (moment().valueOf() > moment(ent).valueOf()) {
                this.str = "已逾期";
            } else if (moment(start).valueOf() > moment().valueOf()) {
                this.str = "未到探店时间";
            }
        },
        determine() {
            fetchArrive(this.taskApplyId, {
                id: this.taskApplyId,
            })
                .then((res) => {
                    if (res.data.result) {
                        this.$router.push("/succeed");
                    } else {
                        this.$router.push({
                            path: "/ToStore",
                            query: {
                                arriveCheckTime: res.data.arriveCheckTime
                            }
                        })
                    }
                })
                .finally(() => {
                    this.closeLoading();
                });
        },
    },
};
</script>
<style scoped lang="less">
.page {
    z-index: 1;
    position: relative;
    width: 375px;
    // height: 896px;
    background-color: rgba(255, 255, 255, 1);
    overflow: hidden;
    justify-content: flex-start;
    padding-top: 0;

    .block1 {
        z-index: auto;
        width: 375px;
        height: 658px;

        .outer2 {
            z-index: 2;
            height: 44px;
            background-color: rgba(255, 255, 255, 1);
            width: 375px;
            justify-content: center;
            align-items: flex-start;
            padding-left: 25px;

            .main4 {
                z-index: auto;
                width: 197px;
                height: 24px;
                justify-content: space-between;

                .label1 {
                    z-index: 24;
                    width: 19px;
                    height: 19px;
                    margin-top: 3px;
                }

                .word3 {
                    z-index: 22;
                    width: 68px;
                    display: block;
                    overflow-wrap: break-word;
                    color: rgba(36, 40, 51, 1);
                    font-size: 17px;
                    font-family: PingFangSC-Medium;
                    white-space: nowrap;
                    line-height: 24px;
                    text-align: center;
                    margin-left: 33vw;
                }
            }
        }

        .txt1 {
            z-index: 39;
            width: 243px;
            display: block;
            overflow-wrap: break-word;
            color: rgba(0, 0, 0, 1);
            font-size: 17px;
            font-family: PingFangSC-Medium;
            white-space: nowrap;
            line-height: 24px;
            text-align: left;
            align-self: flex-start;
            margin: 27px 0 0 27px;
        }

        .info1 {
            z-index: 41;
            width: 64px;
            display: block;
            overflow-wrap: break-word;
            color: rgba(23, 31, 36, 1);
            font-size: 14px;
            font-family: PingFangSC-Medium;
            white-space: nowrap;
            line-height: 21px;
            text-align: left;
            align-self: flex-start;
            margin: 10px 0 0 30px;
        }

        .outer3 {
            z-index: 40;
            height: 140px;
            border-radius: 10px;
            background-color: rgba(255, 255, 255, 1);
            box-shadow: 0px 1px 5px 0px rgba(216, 216, 216, 1);
            align-self: center;
            margin-top: 14px;
            width: 345px;
            justify-content: center;
            align-items: flex-end;
            padding-right: 10px;

            .main5 {
                z-index: auto;
                width: 320px;
                height: 100px;
                justify-content: space-between;

                .pic1 {
                    z-index: 42;
                    width: 100px;
                    height: 100px;
                }

                .group1 {
                    z-index: auto;
                    width: 200px;
                    height: 99px;
                    margin-top: 1px;

                    .main6 {
                        z-index: auto;
                        width: 200px;
                        height: 16px;
                        justify-content: space-between;

                        .info2 {
                            z-index: 44;
                            width: 83px;
                            display: block;
                            overflow-wrap: break-word;
                            color: rgba(170, 178, 183, 1);
                            font-size: 12px;
                            white-space: nowrap;
                            line-height: 16px;
                            text-align: left;
                        }

                        .txt2 {
                            z-index: 45;
                            width: 48px;
                            display: block;
                            overflow-wrap: break-word;
                            color: #17c1ce;
                            font-size: 12px;
                            white-space: nowrap;
                            line-height: 16px;
                            text-align: left;
                        }
                    }

                    .word4 {
                        z-index: 47;
                        width: 193px;
                        display: block;
                        overflow-wrap: break-word;
                        color: rgba(0, 0, 0, 0.85);
                        font-size: 14px;
                        white-space: nowrap;
                        line-height: 21px;
                        text-align: left;
                        align-self: flex-start;
                        margin-top: 4px;
                    }

                    .info3 {
                        z-index: 46;
                        width: 83px;
                        display: block;
                        overflow-wrap: break-word;
                        color: rgba(170, 178, 183, 1);
                        font-size: 12px;
                        white-space: nowrap;
                        line-height: 16px;
                        text-align: left;
                        align-self: flex-start;
                        margin-top: 17px;
                    }

                    .word5 {
                        z-index: 48;
                        width: 48px;
                        display: block;
                        overflow-wrap: break-word;
                        color: rgba(0, 0, 0, 0.85);
                        font-size: 14px;
                        white-space: nowrap;
                        line-height: 21px;
                        text-align: left;
                        align-self: flex-start;
                        margin-top: 4px;
                    }
                }
            }
        }

        .outer4 {
            z-index: auto;
            width: 315px;
            height: 21px;
            justify-content: space-between;
            margin: 18px 0 0 30px;

            .word6 {
                z-index: 49;
                width: 64px;
                display: block;
                overflow-wrap: break-word;
                color: rgba(23, 31, 36, 1);
                font-size: 14px;
                font-family: PingFangSC-Medium;
                white-space: nowrap;
                line-height: 21px;
                text-align: left;
            }

            .txt3 {
                z-index: 50;
                width: 85px;
                display: block;
                overflow-wrap: break-word;
                color: rgba(224, 32, 32, 1);
                font-size: 14px;
                white-space: nowrap;
                line-height: 21px;
                text-align: left;
            }
        }

        .outer5 {
            z-index: 21;
            height: 194px;
            border-radius: 10px;
            background-color: rgba(255, 255, 255, 1);
            box-shadow: 0px 1px 5px 0px rgba(216, 216, 216, 1);
            align-self: center;
            margin-top: 14px;
            width: 345px;
            justify-content: center;
            align-items: center;

            .main7 {
                z-index: auto;
                width: 343px;
                height: 154px;

                .section1 {
                    z-index: auto;
                    width: 198px;
                    height: 73px;
                    margin-left: 24px;
                    justify-content: space-between;

                    .block2 {
                        z-index: 62;
                        width: 70px;
                        height: 70px;
                        border-radius: 35px;
                        box-shadow: 0px 1px 5px 0px rgba(216, 216, 216, 1);
                        background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngd8bb6c2f399e1bc8295332b2f21c65dd625ec6571cc84e13a6dfab37e7b250de) -5px -4px no-repeat;
                        margin-top: 1px;
                    }

                    .block3 {
                        z-index: auto;
                        width: 101px;
                        height: 73px;

                        .word7 {
                            z-index: 61;
                            width: 101px;
                            display: block;
                            overflow-wrap: break-word;
                            color: rgba(0, 0, 0, 0.85);
                            font-size: 14px;
                            font-family: PingFangSC-Medium;
                            white-space: nowrap;
                            line-height: 21px;
                            text-align: left;
                        }

                        .main8 {
                            z-index: auto;
                            width: 87px;
                            height: 17px;
                            margin-top: 10px;
                            justify-content: space-between;

                            .txt4 {
                                z-index: 59;
                                width: 55px;
                                display: block;
                                overflow-wrap: break-word;
                                color: rgba(170, 178, 183, 1);
                                font-size: 12px;
                                white-space: nowrap;
                                line-height: 16px;
                                text-align: left;
                            }

                            .word8 {
                                z-index: 60;
                                width: 20px;
                                display: block;
                                overflow-wrap: break-word;
                                color: rgba(0, 0, 0, 0.85);
                                font-size: 12px;
                                white-space: nowrap;
                                line-height: 17px;
                                text-align: right;
                            }
                        }

                        .main9 {
                            z-index: auto;
                            width: 96px;
                            height: 17px;
                            margin-top: 8px;
                            justify-content: space-between;

                            .word9 {
                                z-index: 55;
                                width: 60px;
                                display: block;
                                overflow-wrap: break-word;
                                color: rgba(170, 178, 183, 1);
                                font-size: 12px;
                                white-space: nowrap;
                                line-height: 16px;
                                text-align: left;
                                margin-top: 1px;
                            }

                            .txt5 {
                                z-index: 56;
                                width: 29px;
                                display: block;
                                overflow-wrap: break-word;
                                color: rgba(0, 0, 0, 0.85);
                                font-size: 12px;
                                white-space: nowrap;
                                line-height: 17px;
                                text-align: right;
                            }
                        }
                    }
                }

                .section2 {
                    z-index: 51;
                    width: 343px;
                    height: 1px;
                    background-color: rgba(238, 238, 238, 1);
                    margin-top: 16px;
                }

                .section3 {
                    z-index: auto;
                    width: 282px;
                    height: 17px;
                    margin: 16px 0 0 24px;

                    .txt6 {
                        z-index: 30;
                        width: 61px;
                        display: block;
                        overflow-wrap: break-word;
                        color: rgba(170, 178, 183, 1);
                        font-size: 12px;
                        white-space: nowrap;
                        line-height: 16px;
                        text-align: left;
                        margin-top: 1px;
                    }

                    .info4 {
                        z-index: 27;
                        width: 24px;
                        display: block;
                        overflow-wrap: break-word;
                        color: rgba(0, 0, 0, 0.85);
                        font-size: 12px;
                        white-space: nowrap;
                        line-height: 17px;
                        text-align: left;
                        margin-left: 13px;
                    }

                    .word10 {
                        z-index: 34;
                        width: 84px;
                        display: block;
                        overflow-wrap: break-word;
                        color: rgba(170, 178, 183, 1);
                        font-size: 12px;
                        white-space: nowrap;
                        line-height: 16px;
                        text-align: left;
                        margin: 1px 0 0 66px;
                    }

                    .word11 {
                        z-index: 35;
                        width: 27px;
                        display: block;
                        overflow-wrap: break-word;
                        color: rgba(0, 0, 0, 0.85);
                        font-size: 12px;
                        white-space: nowrap;
                        line-height: 17px;
                        text-align: right;
                        margin-left: 7px;
                    }
                }

                .section4 {
                    z-index: auto;
                    width: 241px;
                    height: 21px;
                    justify-content: space-between;
                    margin: 10px 0 0 24px;

                    .word12 {
                        z-index: 37;
                        width: 74px;
                        display: block;
                        overflow-wrap: break-word;
                        color: rgba(170, 178, 183, 1);
                        font-size: 12px;
                        white-space: nowrap;
                        line-height: 16px;
                        text-align: left;
                        margin-top: 5px;
                    }

                    .outer6 {
                        z-index: 38;
                        width: 167px;
                        height: 21px;
                        overflow-wrap: break-word;
                        text-align: left;
                        white-space: nowrap;
                        font-size: 0;

                        .txt7 {
                            font-size: 12px;
                            font-family: ArialMT;
                            color: #17c1ce;
                            line-height: 21px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }

                        .word13 {
                            font-size: 12px;
                            font-family: ArialMT;
                            color: rgba(0, 0, 0, 0.85);
                            line-height: 21px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }

                        .word14 {
                            font-size: 12px;
                            color: #17c1ce;
                            line-height: 21px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }

                        .word15 {
                            font-size: 12px;
                            color: rgba(0, 0, 0, 0.85);
                            line-height: 21px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }

                        .info5 {
                            font-size: 12px;
                            color: #17c1ce;
                            line-height: 21px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                    }
                }
            }
        }

        .outer7 {
            z-index: 64;
            height: 36px;
            border-radius: 5px;
            background: #17c1ce;
            align-self: center;
            margin-top: 51px;
            width: 164px;
            justify-content: center;
            align-items: center;

            .word16 {
                z-index: 65;
                width: 64px;
                display: block;
                overflow-wrap: break-word;
                color: rgba(255, 255, 255, 1);
                font-size: 16px;
                font-family: PingFangSC-Medium;
                white-space: nowrap;
                line-height: 22px;
                text-align: left;
            }
        }
    }
}

body * {
    box-sizing: border-box;
    flex-shrink: 0;
}

body {
    font-family: PingFangSC-Regular, Roboto, Helvetica Neue, Helvetica, Tahoma,
        Arial, PingFang SC-Light, Microsoft YaHei;
}

button {
    margin: 0;
    padding: 0;
    border: 1px solid transparent;
    outline: none;
    background-color: transparent;
}

button:active {
    opacity: 0.6;
}

.flex-col {
    display: flex;
    flex-direction: column;
}

.flex-row {
    display: flex;
    flex-direction: row;
}
</style>
